import { logDebug, logError } from "./utils/log";
import { gitSha as currentVersion } from "./version";

let hasNewVersion = false;
let newVersion: string | undefined;
let isUpdating = false;

export function checkVersion(version: unknown) {
  if (currentVersion !== undefined && typeof version === "string" && version !== currentVersion) {
    logDebug(`updater: New version available: ${version} (current=${currentVersion})`);
    hasNewVersion = true;
    newVersion = version;
  }
}

const updatedToVersionKey = "updater__updatedToVersion";

export function updateIfNewVersionAvailable() {
  if (!hasNewVersion || isUpdating) {
    return;
  }

  isUpdating = true;

  const prevNewVersion = sessionStorage.getItem(updatedToVersionKey);
  if (prevNewVersion === newVersion) {
    logError("updater: trying to update to the same version twice in a row, skipping.", {
      currentVersion,
      newVersion,
    });
    return;
  }

  logDebug("updater: Reloading to get new version");
  sessionStorage.setItem(updatedToVersionKey, String(newVersion));
  window.location.reload();
  return true;
}

// A chunk can fail to load after a deploy before any API response has brought the new X-Version.
// Ask the server for its version instead of waiting for one. Reload only when it differs from the
// running build, so a chunk that fails for another reason (ad blocker, network) does not reload in a loop.
export async function updateAfterChunkError() {
  try {
    const response = await fetch("/", { method: "HEAD", cache: "no-store" });
    checkVersion(response.headers.get("x-version"));
  } catch (error) {
    logDebug("updater: Failed to fetch the server version", { error });
  }
  updateIfNewVersionAvailable();
}
